import { WEEK_DAYS } from '@/utils/constants';
import type { IScheduleItem } from '@/types/interfaces/common';

/**
 * Получение дня из графика
 */
export default function (
	weekday: number,
	schedule: IScheduleItem[]
): IScheduleItem {
	return (
		schedule.find(item => WEEK_DAYS[item.prefix_en] === weekday) || schedule[0]
	);
}
